import { ApiClient } from '@inspace-org/client';
import { language } from '../../localization';
import env from '../../env';
import { apiCredentials } from './credentials';

export const api = new ApiClient({ baseUrl: env.apiUrl, prefix: '/api', credentials: apiCredentials, language });
